import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined'
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined'
import { Menu } from '@mui/material'
import { Fragment, ReactElement, ReactNode, useState } from 'react'
import { Link } from 'react-router-dom'
import { MenuItemApp } from '../menu/menu-item-app'
import { TabApp, TabAppProps } from './tab-app'
import { AnalyticsEventName, AnalyticsTracker } from '@/infra/tracking'

type OptionValueType = string | number | boolean

type TabMenuAppProps = TabAppProps & {
  options: { label: ReactNode; value: OptionValueType; to: string }[]
}

export function TabMenuApp({ label, options, ...props }: TabMenuAppProps): ReactElement {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleTabClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (open) {
      handleClose()
    } else {
      setAnchorEl(event.currentTarget)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleItemClick = (value: OptionValueType) => {
    handleClose()
    AnalyticsTracker.trackEvent(AnalyticsEventName.HEADER_NAVIGATE, {
      destination: String(value)
    })
  }

  const menuLabel = (
    <span className="flex items-center">
      {label}
      {open ? <ArrowDropUpOutlinedIcon /> : <ArrowDropDownOutlinedIcon />}
    </span>
  )

  return (
    <Fragment>
      <TabApp label={menuLabel} onClick={handleTabClick} {...props} />

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              ml: -2,
              '& .MuiMenuItem-root': {
                pr: 8
              }
            }
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        disableScrollLock
      >
        {options.map((option, index) => (
          <MenuItemApp
            key={`${option.value}-${index}`}
            component={Link}
            toRoute={{
              value: option.to,
              title: option.label as string,
              name: option.value as string
            }}
            onClose={() => {
              handleItemClick(option.value)
            }}
          >
            {option.label}
          </MenuItemApp>
        ))}
      </Menu>
    </Fragment>
  )
}
